<template>
    <el-container>
        <!-- <el-header>Header</el-header> -->
        <el-main>
            <img alt="" src="static/xiaoqi.jpg" width="30%" height="auto">
            <div style="width: 80%;margin: 0 auto;">
              <el-row :gutter="20">
                <el-col :span="6">
                    &nbsp;
                </el-col>
                <el-col :span="6">
                  <el-card :body-style="{ padding: '10px', height: '300px' }" shadow="hover">
                    <img src="static/gaoya.jpg" class="image" width="auto" height="90%">
                    <div style="padding: 5px; text-align: left">
                      <span>《电力变压器高压绝缘特性虚拟仿真实验》</span>

                    </div>
                  </el-card>
                </el-col>
                <el-col :span="6">
                  <el-card :body-style="{ padding: '10px',  height: '300px'}" shadow="hover">
                    <span><el-tag type="success"  effect="dark">登录实验室</el-tag></span>
                    <el-divider></el-divider>
                    <el-form ref="form" :model="form" label-width="0px">
                    <el-form-item>
                        <el-input v-model="form.username" placeholder="请输入工号或者学号" prefix-icon="el-icon-user-solid"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input type="password" v-model="form.password" placeholder="请输入密码" prefix-icon="el-icon-s-cooperation"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div ref="imagcode" style="background-image: url(https://wx.hnjt.edu.cn/payinvoiceapp/code/image); background-size: cover; height: 23px; width: 67px;" @click="resetCode"></div>
                        <el-input v-model="form.imagcode" placeholder="请输入验证码" prefix-icon="el-icon-s-claim"></el-input>
                    </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="onSubmit">登录</el-button>
                        <el-button>取消</el-button>
                    </el-form-item>
                    </el-form>

                  </el-card>
                </el-col>
              </el-row> 
            </div>
        </el-main>
        <!-- <el-footer>Footer</el-footer> -->
    </el-container>
</template>


<script>
import CryptoJs from 'crypto-js';
import axios from '@/assets/axios';

export default {
  data () {
    return {
      currentDate: new Date(),
      form: {
          username: '',
          password: '',
          imagcode: ''
      }
    }
  },
  created:function(){
    if (!sessionStorage.getItem('indexed')){
      this.$router.push({path: "/"});
    }
  },
  mounted:function(){
    axios.get('https://wx.hnjt.edu.cn/payinvoiceapp/xlab/visit', {
      params: {
        code: "gw"
      }
    })
    .then(function (response) {

    })
    .catch(function (error) {
      console.log(error);
    });
  },
  methods: {
    onSubmit() {
      const that = this;
      const md5pw = "" + CryptoJs.MD5(this.form.password).toString();
      axios.post('https://wx.hnjt.edu.cn/payinvoiceapp/auth/login' , {
          // params: {
            username: this.form.username,
            password: md5pw,
            imagecode: this.form.imagcode
          // }
        })
        .then(function (response) {
          if (response.status == 200){
            // sessionStorage.setItem("user", that.form.username);
            // that.$router.push({path: "/gaoya/index"});
            that.$alert('用户名密码或验证码不正确', '登录失败', {
              confirmButtonText: '确定',
              callback: action => {
                that.form.username = '',
                that.form.password = '',
                that.form.imagcode = '',
                that.resetCode();
              }
            });
          }else{
            that.$alert('用户名密码或验证码不正确', '登录失败', {
              confirmButtonText: '确定',
              callback: action => {
                that.form.username = '',
                that.form.password = '',
                that.form.imagcode = '',
                that.resetCode();
              }
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    resetCode() {
      let r = Math.floor(Math.random() * 1000);
      this.$refs.imagcode.style.backgroundImage = "url('https://wx.hnjt.edu.cn/payinvoiceapp/code/image?v="+r+"')";
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-header, .el-footer {
    /* background-color: #B3C0D1; */
    color: #333;
    text-align: center;
    line-height: 60px;
  }

  
  .el-main {
    background-color: #0068B7;
    /* color: #333; */
    text-align: center;
    /* line-height: 160px; */
    width: 100%;
    height: 100vh;
    overflow: hidden; 
    margin:0;
    padding:0;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/GaoYa/Login.vue